<!-- 工资管理卡片列表 -->
<template>
    <a-card title="工资管理" style="margin-bottom: 16px;">
        <template slot="extra">
            <div style="display: flex;">
                <a-button  v-if="detail.bankFlowApprovalState === APPROVAL_STATE_TO_BE_APPROVED"  type="primary" style="margin-right: 8px;" @click="handleOpenConfirmModal(detail.bankFlowApprovalState)">
                    工资核准
                </a-button>
                <a-button v-else type="primary" @click="handleOpenConfirmModal(detail.bankFlowApprovalState)">
                    核准结果
                </a-button>
            </div>
        </template>
        <div class="steps-info">
            <p><b>工资月：</b>{{ commonParams.attendanceMonthDesc }}</p>
            <p><b>签字扫描：</b>{{ detail.signedDocumentsText }}</p>
            <p><b>应发总金额：</b>{{ detail.wagesToBePaid }}</p>
            <p><b>核准状态：</b><span class="status">{{ detail.bankFlowApprovalStateText }}</span></p>
        </div>
        <a-card title="工资记录" size="small">
            <template slot="extra">
                <div style="display: flex;">
                    <a-button type="link" @click="handleOpenSignFileModal">
                        签字扫描件
                    </a-button>
                    <a-button type="link" @click="handleOpenBatchImportModal">
                        导入工资表
                    </a-button>
                </div>
            </template>
            <custom-table
                row-key="id"
                size="middle"
                :pagination="pagination"
                :loading="loading"
                :scroll="scrollConfig"
                :columns="salaryListColumns"
                :data-source="dataList"
            />
        </a-card>
        <sign-file-modal ref="signFileModalRef" :params="commonParams" @on-refresh="reload" />
        <batch-import-modal ref="batchImportModalRef" :params="commonParams" @on-refresh="reload" />
        <confirm-modal ref="confirmModalRef" :common-params="commonParams" :detail="detail" @on-refresh="reload" />
    </a-card>
</template>

<script>
import { Button as AButton, Card as ACard } from 'ant-design-vue'
import CustomTable from '@components/CustomTable'
import SignFileModal from './SignFileModal'
import BatchImportModal from './BatchImportModal'
import ConfirmModal from './ConfirmModal'
import initTable from '@mixins/initTable'
import { APPROVAL_STATE_TO_BE_APPROVED, APPROVAL_STATE_APPROVED, APPROVAL_STATE_NOT_APPROVED } from '@/constant/enum'
import { SALARY_LIST_COLUMNS } from './config'
import { getSalaryInfoPage, getSalaryMonthInfoById, pushSalaryBankFlowReconciliation } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'SalaryCard',
    components: {
        AButton,
        CustomTable,
        ACard,
        SignFileModal,
        BatchImportModal,
        ConfirmModal
    },
    mixins: [initTable],
    props: {
        commonParams: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            APPROVAL_STATE_TO_BE_APPROVED,
            detail: {},
            salaryListColumns: Object.freeze(SALARY_LIST_COLUMNS),
            scrollConfig: Object.freeze({
                x: 1000,
                y: 500
            }),
            loading: false
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        handleOpenSignFileModal() {
            this.$refs.signFileModalRef.open()
        },
        handleOpenBatchImportModal() {
            this.$refs.batchImportModalRef.open()
        },
        async handleOpenConfirmModal(bankFlowApprovalState) {
            switch (bankFlowApprovalState) {
                // 待发起核准（需要先发起核准，变成待确认核准）
                // 待确认核准
                case APPROVAL_STATE_TO_BE_APPROVED:
                case APPROVAL_STATE_NOT_APPROVED:
                    try {
                        const { operationNumber } = await pushSalaryBankFlowReconciliation({
                            projectCode: this.commonParams.projectCode,
                            monthDesc: this.commonParams.attendanceMonthDesc
                        })
                        await this.getInfo()
                        this.detail.operationNumber = operationNumber
                        this.$refs.confirmModalRef.open()
                    } catch (e) {
                        this.$message.error(e.message)
                    }
                    break
                    // 已核准
                case APPROVAL_STATE_APPROVED:
                    this.$refs.confirmModalRef.open()
                    break
                default:
                    break
            }
        },
        reload() {
            this.current = 1
            this.getList()
            this.getInfo()
            this.$emit('reload')
        },
        async getInfo() {
            try {
                this.loading = true
                const result = await getSalaryMonthInfoById({
                    id: this.commonParams.salaryMonthId
                })
                this.detail = result
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        // 获取分页列表数据
        async getList() {
            try {
                this.loading = true

                const result = await getSalaryInfoPage({
                    projectCode: this.commonParams.projectCode,
                    salaryMonthDesc: this.commonParams.attendanceMonthDesc,
                    ...this.params
                })

                this.total = result.total || 0
                this.dataList = result.records || []
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
